import { Modal } from "antd";

const cancelConfirmation = (handleCancel) => {
  Modal.confirm({
    title: "Discard changes?",
    content: "You have unsaved changes. Are you sure you want to cancel?",
    okText: "Yes, Discard",
    cancelText: "No, Keep Editing",
    onOk: () => {
      handleCancel();
    }
  });
}

export default cancelConfirmation;
